import { JobStatusDisplayMap, PayType } from '~/api/jobs'
import { BadgeVariant } from '~/design_system/types'
import { useIsSanaRebrandEnabled } from '~/theme/useIsSanaRebrandEnabled'

export function useJobStatusBadgeState(): JobStatusDisplayMap<BadgeVariant> {
  const isRebrand = useIsSanaRebrandEnabled()
  return {
    Draft: 'incomplete',
    Hold: 'incomplete',
    Active: 'success',
    Closed: isRebrand ? 'complete' : 'danger',
    Pending: 'pending',
    'Pending Approval': 'pending',
    Rejected: 'danger'
  }
}

export const getStatusBadgeTokenID = new Map<string, string>([
  ['Draft', 'term.draft'],
  ['Hold', 'term.hold'],
  ['Active', 'term.active'],
  ['Closed', 'common.ui.closed'],
  ['Pending', 'term.pending'],
  ['Pending Approval', 'common.ui.pending_approval'],
  ['Rejected', 'common.ui.rejected']
])

export const isCalcEngineSupportedForPayType = (payType: number, isDirectHire: boolean) => {
  // when we update this function check also job_form.js and update getProgramRateType function
  if (isDirectHire) {
    return false
  }
  const supportedPayTypes = [PayType.HOURLY, PayType.DAILY, PayType.WEEKLY, PayType.MONTHLY]
  return supportedPayTypes.includes(payType)
}
